import { translate } from "app/filters/i18nFilter";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import type { Filter } from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { SearchOverviewTexts } from "../../texts";

export const getSubtitleFilters = (country: number | null, duration: string, webSource: string): Filter[] => {
    const countryName = country && CountryService.getCountryById(country)?.text;
    const { to } = DurationService.getDurationData(duration).forAPI;

    return [
        {
            filter: "date" as const,
            value: { to },
        },
        {
            filter: "country" as const,
            countryCode: country,
            value: countryName,
        },
        {
            filter: "webSource" as const,
            value: webSource,
        },
    ];
};

export const getFooterButtonConfig = (params: Record<string, any>) => [
    {
        type: buttonTypes.FLAT,
        text: translate(SearchOverviewTexts.seeAll),
        link: proNavigator.href("organicsearch_website_search_ranking_distribution_v2", params),
        onClick: () => allTrackers.dispatchTrackEvent("Internal Link", "click", "Overview/Rank 1-3"),
    },
];
